import { render, staticRenderFns } from "./TableWithWrapper.vue?vue&type=template&id=50052e17&"
import script from "./TableWithWrapper.vue?vue&type=script&lang=js&"
export * from "./TableWithWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports